<template>
  <smart-banner
    v-if="!hasConflict"
    :class="classes"
    :bg-color="bgColor"
    :direction="direction"
    :has-kicker="false"
    title-color="#3b3b3b"
    title-size="h2"
    title-weight="400"
    title-align="left"
    text-color="#43515A"
    text-size="md"
    text-weight="400"
    text-align="left"
    :has-button="false"
    :has-image="hasImage"
    :image-mobile="imageMobile"
    :image-tablet="imageTablet"
    :image-desktop="imageDesktop"
    :alt="alt"
    :center-items="false"
    :reduce-width="false"
    :has-video="hasVideo"
  >
    <template v-slot:video>
      <slot name="quinary-video" />
    </template>
    <template v-slot:title>
      <slot name="quinary-title" />
    </template>
    <template v-slot:text>
      <slot name="quinary-text" />
    </template>
  </smart-banner>
</template>

<script>
import SmartBanner from './smart-banner.vue'

export default {
  name: 'smart-banner-quinary',
  components: {
    SmartBanner,
  },
  props: {
    direction: {
      type: String,
    },
    imageMobile: {
      type: String,
    },
    imageTablet: {
      type: String,
    },
    imageDesktop: {
      type: String,
    },
    alt: {
      type: String,
    },
    bgColor: {
      type: String,
      default: '#FFFFFF',
    },
    hasVideo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      classes: [
        'smart-banner',
        `smart-banner--${this.direction}`,
      ],
      hasImage: Boolean(this.imageMobile || this.imageTablet || this.imageDesktop),
    }
  },
  computed: {
    hasConflict() {
      return this.hasVideo && this.hasImage
    }
  },
}
</script>
